import { EventCheckInTableInstance } from './instance';

const redeemableTicketsSearchFields = EventCheckInTableInstance.createSearchFields([
  [
    'search',
    {
      fields: ['name'],
      placeHolder: 'Search Ticket Holder Name',
    },
  ],
  [
    'search',
    {
      fields: ['uuid'],
      placeHolder: 'Search Ticket Id',
    },
  ],
]);

export { redeemableTicketsSearchFields };
